module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-6.9458f118.mp3";